import styled from '@xstyled/styled-components'
import type { HTMLXStyledProps } from '../../system'
import type {
  DialogContentProps,
  DialogFooterProps,
  DialogHeaderProps
} from '../DialogV2'
import type { CloseButtonProps } from '../closeButton'
import type { Size } from './types'

export type SizableStyleProps = {
  closeButton: CloseButtonProps
  listItem: HTMLXStyledProps<'li'>
  header: DialogHeaderProps
  content: DialogContentProps
  footer: DialogFooterProps
}

const sizableStyles: Record<Size, SizableStyleProps> = {
  lg: {
    closeButton: {},
    listItem: {
      text: 'md',
      h: '40rpx',
      py: 0,
      px: 4,
      mx: '-8rpx'
    },
    header: { px: 6, py: 4 },
    content: { px: 4, py: 0 },
    footer: { py: 4 }
  },
  sm: {
    closeButton: {
      size: 'sm'
    },
    listItem: {
      text: 'sm',
      h: '32rpx',
      py: 0,
      px: 3
    },
    header: {
      text: 'sm',
      pt: 2.5,
      px: 3,
      pb: 1
    },
    content: {
      py: 1,
      px: 2.5
    },
    footer: {
      py: 1.5,
      px: 3
    }
  }
}

export function getSizableStyles(size: Size) {
  return sizableStyles[size]
}

export const TranslationLanguageItem = styled.liBox(props => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  color: props.theme.colors.grey.d3,
  fontWeight: props.theme.fontWeights.medium,
  borderRadius: props.theme.radii.md,
  userSelect: 'none',
  outline: 'transparent solid 2px !important',
  outlineOffset: '2px',
  scrollSnapAlign: 'start',
  transition: 'all 150ms ease',
  '&:hover, &:focus': { background: props.theme.colors.grey.l3 },
  '&:active': { background: props.theme.colors.grey.l2 },
  '&[data-selected]': {
    cursor: 'default',
    '&:hover, &:focus': { background: 'transparent' }
  }
}))
